import { ReactNode } from 'react';

import type { Platform } from '@/domains/core/settings/interfaces/Platform';
import { getPlatform, isB2B } from '@/domains/core/settings/utils';
import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { concreteGuaranteeContent } from '@/domains/productDiscovery/ProductPage/common/modules/GoodToKnow/translations';

const concreteGuaranteePageId: Record<Platform, string> = {
  gb: `/lp/concrete-guarantee-${isB2B() ? 3895 : 3964}`,
  it: `/lp/garanzia-cemento-${isB2B() ? 3762 : 3962}`,
  es: `/lp/garantia-hormigon-${isB2B() ? 3928 : 3963}`,
  de: `/lp/manomano-garantie-${isB2B() ? 3862 : 3961}`,
  fr: `/lp/garantie-beton-${isB2B() ? 3729 : 3429}`,
};

export const concreteGuaranteeUrl = `${concreteGuaranteePageId[getPlatform()]}`;

export const ConcreteGuarantee = () => {
  return (
    <Typography scale="body2">
      {concreteGuaranteeContent.format({
        strong: (chunks) => <strong>{chunks}</strong>,
        br: () => <br key="br" />,
        a: (chunks: ReactNode) => (
          <a href={concreteGuaranteeUrl} target="_blank" rel="noreferrer">
            {chunks}
          </a>
        ),
      })}
    </Typography>
  );
};
